module.exports = __webpack_public_path__ + "img/EAJ1.5d7a0842.png";